import { Component, Inject, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-document-requirement-notes',
  templateUrl: './document-requirement-notes.component.html',
  styleUrls: ['./document-requirement-notes.component.scss']
})
export class DocumentRequirementNotesComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  title: any;
  claimId: any;
  showUpload: boolean = false;
  addIcon = this.RESOURCE_SERVER_URL + '/assets/images/addPurple.svg';
  editIcon = this.RESOURCE_SERVER_URL + '/assets/images/Edit.svg';
  deleteIcon = this.RESOURCE_SERVER_URL + '/assets/images/Delete.svg';
  uploadIcon =
    this.RESOURCE_SERVER_URL +
    '/assets/images/process-claims/icons/upload_file.svg';
  value: any;
  isLoading: boolean = false;
  notes: any;
  requirement: any;
  claimsRequirementId: any;
  claimsRequirementInfoId: any;
  enableEdit: boolean = false;
  isDeleteConfirmation: boolean = false;
  delRequirement: any;
  editList: any = [];
  requirementStatus: any;

  constructor(
    private commonService: CommonService,
    private dialogRef: MatDialogRef<DocumentRequirementNotesComponent>,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit(): void {
    console.log('this is data ', this.data);
    this.claimId = this.data.claimID;
    this.title = this.data.title;
    this.requirement = this.data.requirement;
    console.log('test method', this.requirement);
    this.claimsRequirementId = this.data.requirementId;
    console.log('reqid:', this.claimsRequirementId);
    this.claimsRequirementInfoId = this.data.requirementInfoId;
    this.requirementStatus = this.data.requirementStatus;
    // this.getNotesList();
  }
  // async getNotesList() {
  //   this.isLoading = true;

  //   try {
  //     let url =
  //       environment.API_CLAIM_OFFICE_SERVER_URL +
  //       this.claimId +
  //       '/requirementInfos/' +
  //       this.claimsRequirementInfoId +
  //       '/requirements/' +
  //       this.claimsRequirementId +
  //       '/notes';
  //     let response = await this.commonService.commonGet(url);
  //     this.notes = response.body._links.item;
  //     if (this.notes == undefined)
  //       this.notes = [];
  //     else {
  //       for (let item of this.notes) {
  //         item.summary.isEdit = false;
  //       }
  //     }
  //     console.log('getList', this.notes);
  //     this.isLoading = false;
  //   } catch (err) {
  //     console.log('claimNotes List err', err);
  //     this.isLoading = false;
  //   }
  // }
  onCloseDialog() {
    this.dialogRef.close();
  }
  onChange(event, index: number) {
    this.notes[index].summary.freeText = event.value;
  }
  async onDataBlur(data, index: number) {
    this.isLoading = true;
    let body = {};
    // body['freeText'] = this.notes[index].summary.freeText;
    // try {
    //   let url =
    //     environment.API_CLAIM_OFFICE_SERVER_URL +
    //     this.claimId +
    //     '/requirementInfos/' +
    //     this.claimsRequirementInfoId +
    //     '/requirements/' +
    //     this.claimsRequirementId +
    //     '/notes/' +
    //     this.notes[index].summary.uuid;
    //   await this.commonService.commonPatch(url, body);
    //   this.isLoading = false;
    // } catch (err) {
    //   console.log('patch claim notes List err', err);
    //   this.isLoading = false;
    // }
  }
  async onAddNote() {
    // try {
    //   let url =
    //     environment.API_CLAIM_OFFICE_SERVER_URL +
    //     this.claimId +
    //     '/requirementInfos/' +
    //     this.claimsRequirementInfoId +
    //     '/requirements/' +
    //     this.claimsRequirementId +
    //     '/notes';
    //   let response = await this.commonService.commonPost(url, {});
    //    await this.getNotesList();
    //   this.isLoading = false;
    // } catch (err) {
    //   console.log('create claim note List err', err);
    //   this.isLoading = false;
    // }
  }
  onDeleteConfirmation(data) {
    this.isDeleteConfirmation = true;
    this.delRequirement = data.summary.uuid;
    console.log('delete uuid:::', this.delRequirement);
  }
  async onDeleteNote() {
    // this.isLoading = true;
    // let notesId = this.delRequirement;
    // try {
    //   let url =
    //     environment.API_CLAIM_OFFICE_SERVER_URL +
    //     this.claimId +
    //     '/requirementInfos/' +
    //     this.claimsRequirementInfoId +
    //     '/requirements/' +
    //     this.claimsRequirementId +
    //     '/notes/' +
    //     notesId;
    //   let response = await this.commonService.commonDelete(url);
    //   if (response.body.outcome == 'success') {
    //     this.commonService.showNotifyMessage(
    //       'deleteClaimRequirementsNote',
    //       'success',
    //       3000
    //     );
    //   }
    //   this.getNotesList();
    //   this.onClosePopup();
    //   this.isLoading = false;
    // } catch (err) {
    //   console.log('Claim Delete List err', err);
    //   this.isLoading = false;
    // }
  }

  onClosePopup() {
    this.isDeleteConfirmation = false;
  }

  async onEditNote(index: number) {
    if (!this.notes[index].summary.isEdit) {
      this.editList.push({ uuid: this.notes[index].summary.uuid });
      this.notes[index].summary.isEdit = true;
    }
  }
}
